import Modal from '../../../components/Modal';
import { VoiceExtractionTask } from '../../../types';
import { tosAccelerate } from '../../../utils/tosAccelerate';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface VoiceExtractionModalProps {
  open: boolean;
  extractionTask: VoiceExtractionTask | null;
  extractionLoading: boolean;
  applyingVoice: string | null;
  appliedVoices: Set<string>;
  t: Translate;
  onClose: () => void;
  onApplyVoice: (characterName: string, audioUrl: string) => void;
}

export default function VoiceExtractionModal({
  open,
  extractionTask,
  extractionLoading,
  applyingVoice,
  appliedVoices,
  t,
  onClose,
  onApplyVoice,
}: VoiceExtractionModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('extractionModal.title')}
      width="520px"
    >
      {extractionLoading && !extractionTask ? (
        <div style={{ textAlign: 'center', padding: '2rem 0' }}>
          <span className="loading-spinner" style={{ width: '24px', height: '24px', borderWidth: '3px' }}></span>
          <p style={{ marginTop: '0.5rem', color: 'var(--text-2)', fontSize: '0.85rem' }}>{t('extractionModal.submitting')}</p>
        </div>
      ) : extractionTask?.status === 'pending' || extractionTask?.status === 'processing' ? (
        <div style={{ textAlign: 'center', padding: '2rem 0' }}>
          <span className="loading-spinner" style={{ width: '24px', height: '24px', borderWidth: '3px' }}></span>
          <p style={{ marginTop: '0.5rem', color: 'var(--text-2)', fontSize: '0.85rem' }}>{t('extractionModal.extracting')}</p>
        </div>
      ) : extractionTask?.status === 'failed' ? (
        <div style={{ textAlign: 'center', padding: '2rem 0', color: 'var(--danger)' }}>
          <p style={{ fontSize: '1.2rem' }}>{t('extractionModal.failed')}</p>
          <p style={{ fontSize: '0.82rem' }}>{extractionTask.errorMessage || t('extractionModal.failed')}</p>
        </div>
      ) : extractionTask?.status === 'completed' && extractionTask.segments ? (
        <div>
          <p style={{ fontSize: '0.82rem', color: 'var(--text-2)', marginBottom: '0.75rem' }}>
            {t('extractionModal.segmentCount', { count: extractionTask.segments.length })}
          </p>
          {extractionTask.segments.map((segment, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderBottom: '1px solid var(--border)', flexWrap: 'wrap' }}>
              <span style={{ fontWeight: 600, fontSize: '0.85rem', minWidth: '60px' }}>{segment.character}</span>
              <audio src={tosAccelerate(segment.audio_url)} controls preload="metadata" style={{ height: '28px', flex: '1 1 150px', maxWidth: '200px' }} />
              <span style={{ fontSize: '0.72rem', color: 'var(--text-3)', flex: '1 1 100px' }}>{segment.transcript_text?.slice(0, 30)}</span>
              <button
                onClick={() => onApplyVoice(segment.character, segment.audio_url)}
                disabled={appliedVoices.has(segment.character) || applyingVoice === segment.character}
                style={{
                  background: appliedVoices.has(segment.character) ? '#9ca3af' : 'var(--primary)', color: '#fff', border: 'none',
                  borderRadius: '4px', padding: '3px 12px', fontSize: '0.78rem',
                  cursor: appliedVoices.has(segment.character) ? 'not-allowed' : 'pointer', flexShrink: 0,
                }}
              >
                {applyingVoice === segment.character ? t('extractionModal.applying') : appliedVoices.has(segment.character) ? t('extractionModal.applied') : t('extractionModal.apply')}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ color: 'var(--text-3)', fontSize: '0.85rem' }}>{t('pickerModal.noResources')}</p>
      )}
    </Modal>
  );
}
